<template>
  <el-button type="success" @click="handRedImport()" size="mini" plain style="margin-left:10px">导入红字信息表</el-button>

  <el-dialog v-model="dialogFormVisible" width="30%" title="导入红字信息表">
    <el-form size="mini" label-position="right" label-width="50px">
      <el-form-item label="文件">
        <el-input style="width:200px;margin-right:10px" v-model="path"></el-input>
        <input size="mini" ref="excel-upload-input" class="excel-upload-input" style="display:none" type="file" accept=".xlsx, .xls, .xml" @change="handleClick">
        <el-button type="primary" @click="handleUpload()" size="mini">请选择文件</el-button>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" type="primary" @click="handConfirm()">确定 </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { uploadFile } from "@/api/ea";
import { redInfo } from "@/api/apply";
export default {
  name: 'redUploadComponent',
  data() {
    return {
      dialogFormVisible: false,
      path: '',
    }
  },
  created () {
    
  },
  methods: {
    handRedImport(){
      this.dialogFormVisible = true
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0]; // only use files[0]
      let path = e.target.value; //路径
      this.path = path; //用路径作为标题
      this.files = rawFile//需要上传的文件
    },
    handleUpload() {
      this.$refs["excel-upload-input"].click();
    },
    handConfirm() {
      const files = this.files
      const param = new FormData() // 创建form对象
      if (files !== '') {
        param.append('upFile', files, files.name) // 单个图片 ，多个用循环 append 添加
      } else { 
        this.$message.error('请添加文件')
      }
      uploadFile(param).then(res => {
        if(res.data.msg == "success"){
          const path = res.data.data.path
          // this.$emit('success', path)
          //上传成功 解析xml
          this.getXmlInfo(path)
        }
      })
    },
    getXmlInfo(path){
      let param = {
        "type": "2",
        "path": path,
        "comId": this.$store.getters['user/comInfo'].id*1,
      }
      redInfo(param).then(res=>{
        if(res.data.msg == "success"){
          this.$emit('success', res.data.data.info)
          this.dialogFormVisible = false
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
